import { gql, useLazyQuery } from "@apollo/client";
import { GoodStatus, ListCorporationSelectQuery } from "../gql/graphql";
import { CouponStatus, UserCouponStatus } from "../constants/props";

const GET_CORPORATION = gql`
  query getCorporation($input: GetCorporationInput!) {
    getCorporation(input: $input) {
      ok
      err
      corporation {
        id
        name
        address
        isActive
        operationFrom
        operationTo
        holiday
        ceoName
        origin
        businessName
        businessNumber
        businessAddress
        mainCategories {
          id
          name
          imageUrl
        }
        coupons {
          id
          name
          status
          discountPrice
          validFrom
          validUntil
          userCoupons {
            id
            status
          }
        }
        goods {
          id
          title
          summary
          price
          discountRate
          status
          goodPosters {
            id
            upload {
              url
            }
          }
          goodReviews {
            id
            rating
            note
          }
          subCategory {
            id
            name
          }
        }
      }
    }
  }
`;

export interface GetCorporationInput {
  corporationId: number;
  userId?: number;
}

export interface GetCorporation {
  getCorporation: {
    ok: boolean;
    err?: string;
    corporation: {
      id: string;
      name: string;
      address: string;
      isActive: boolean;
      operationFrom?: string;
      operationTo?: string;
      holiday?: string;
      ceoName?: string;
      businessName?: string;
      businessNumber?: string;
      businessAddress?: string;
      origin?: string;
      mainCategories: {
        id: string;
        name: string;
        imageUrl: string;
      }[];
      coupons: {
        id: number;
        name: string;
        status: CouponStatus;
        discountPrice: number;
        validFrom: string;
        validUntil: string;
        userCoupons?: {
          id: number;
          status: UserCouponStatus;
        }[];
      }[];
      goods: {
        id: string;
        title: string;
        summary: string;
        price: number;
        status: GoodStatus;
        discountRate: number;
        subCategory?: {
          id: string;
          name: string;
        };
        goodPosters: {
          id: string;
          upload: {
            url: string;
          };
        }[];
        goodReviews: {
          id: string;
          rating: number;
          note: string;
        }[];
      }[];
    };
  };
}

export const useGetCorporation = (
  onCompleted?: (data: GetCorporation) => void
) => {
  return useLazyQuery<GetCorporation>(GET_CORPORATION, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
